/* eslint-disable @next/next/no-img-element -- Bypassing the rule because we want to use special values for width and height */
import React from 'react';
import styles from './style.module.scss';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

type ProviderLogoProps = {
  /** The source of the provider logo. If not provided, the logo will not be displayed. */
  src: string | null;
  /** The text to be used as the logo alt text. If not provided, the default logo alt text will be used. */
  alt?: string | null;
};

export default function ProviderLogo({ src, alt }: ProviderLogoProps) {
  const { t } = useTranslation(Namespaces.COMMON);

  if (!src) {
    return null;
  }

  const logoAlt = t(LOCALE_COMMON_PATHS.LISTING_CARD_PROVIDER_LOGO_ALT,
    {
      alt,
      context: alt ? '' : 'default',
    }
  );

  return (
    <div className={styles.imageContainer}>
      <img src={`${src}`} alt={logoAlt} />
    </div>
  );
}